import React from 'react';
import "./index.scss"
import { GatsbyImage, getImage } from 'gatsby-plugin-image';


export default function FeaturedNarrative ({component}) {
  const {textContent, frontImage, backgroundImage} = component;

  return (
    <section data-datocms-noindex className="featured-narrative">

      <GatsbyImage
        image={getImage(backgroundImage)}
        className="featured-narrative__bg-image"
      />

      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <GatsbyImage
              image={getImage(frontImage)}
              className="featured-narrative__front-image"
            />
          </div>
          <div className="col-md-6">
            <article className="featured-narrative__article" dangerouslySetInnerHTML={{__html: textContent}}/>
          </div>
        </div>
      </div>
      
    </section>
  )
}